import React from 'react';
import { Grid } from '@mui/material';
import Skeleton from '@mui/material/Skeleton';

function SkeletonWidget() {
  return (
    <Grid container spacing={1} alignItems="flex-start">
      <Grid item xs={12} sm={6}>
        <Skeleton animation="wave" height="8vh" />
      </Grid>
      <Grid item xs={12} sm={6}>
        <Skeleton animation="wave" height="8vh" />
      </Grid>
      <Grid item xs={12}>
        <Skeleton animation="wave" height="8vh" />
      </Grid>
      <Grid item xs={12}>
        <Skeleton animation="wave" height="8vh" />
      </Grid>
      <Grid item xs={12}>
        <Skeleton animation="wave" height="8vh" />
      </Grid>
      <Grid item xs={12}>
        <Skeleton animation="wave" width="50%" height="8vh" />
      </Grid>
      <Grid item xs={6}>
        <Skeleton animation="wave" height="8vh" />
      </Grid>
      <Grid item xs={6}>
        <Skeleton animation="wave" height="8vh" />
      </Grid>
      <Grid item xs={12}>
        <Skeleton animation="wave" height="8vh" />
      </Grid>
    </Grid>
  );
}

export default SkeletonWidget;
